import { Grid } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { giftconditionApis } from 'api'
import { NA } from 'constans/common'
import { GIFT_CONDITIONS } from 'constans/queryKeys'
import * as urls from 'constans/urls'
import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Container, StatusCard } from 'shared/components'
import DateTimeCell from 'shared/components/DateTimeCell'
import ItemDetails from 'shared/components/ItemDetails'

const ConditionDetails = () => {
  const { conditionId } = useParams()
  const navigate = useNavigate()
  const { data } = useQuery({
    queryKey: [GIFT_CONDITIONS, conditionId],
    queryFn: () => giftconditionApis.getDetails(conditionId || ''),
    enabled: !!conditionId,
  })

  const details = useMemo(() => {
    if (data && data.Result && data.Result) {
      return data.Result[0]
    }
    return undefined
  }, [data])

  const goToEdit = () => {
    navigate(
      `/${urls.GIFT_CONDITION_URLS.EDIT.replace(
        ':conditionId',
        `${details?.Id}` || ''
      )}`
    )
  }

  const goBack = () => {
    navigate(`/${urls.GIFT_CONDITION_URLS.LIST}`)
  }

  return (
    <Container title="Chi tiết điều kiện nhận quà">
      <Grid
        container
        sx={() => ({
          gap: 2,
          '& > div': {
            boxShadow: 1,
            p: 2,
            borderRadius: 2,
            '& > div': {
              height: '100%',
            },
          },
        })}
      >
        <Grid item xs>
          <Grid direction="column" gap={1} container>
            <ItemDetails
              title="Tên sản phẩm"
              value={details?.ProductName || NA}
            />
            <ItemDetails
              title="Mã sản phẩm"
              value={details?.ProductCode || NA}
            />
            <ItemDetails
              title="Số lượng tem"
              value={details?.TemQuantity || NA}
            />
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid direction="column" gap={1} container>
            <ItemDetails
              title="Trạng thái"
              value={
                <StatusCard
                  disableBgColor
                  label={
                    !details?.IsDeleted && details?.IsActive
                      ? 'Hoạt động'
                      : 'Không hoạt động'
                  }
                  type={
                    !details?.IsDeleted && details?.IsActive
                      ? 'active'
                      : 'error'
                  }
                />
              }
            />
          </Grid>
        </Grid>

        <Grid item xs>
          <Grid direction="column" gap={1} container>
            <ItemDetails title="Người tạo" value={details?.CreatedUser || NA} />
            <ItemDetails
              title="Ngày tạo"
              value={<DateTimeCell value={details?.CreatedDate} />}
            />

            <ItemDetails
              title="Người cập nhật"
              value={details?.UpdatedUser || NA}
            />
            <ItemDetails
              title="Ngày cập nhật"
              value={<DateTimeCell value={details?.UpdatedDate} />}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container mt={2} gap={2}>
        <Button onClick={goBack} color="inherit">
          Quay về
        </Button>
        <Button onClick={goToEdit} color="warning">
          Cập nhật
        </Button>
      </Grid>
    </Container>
  )
}

export default ConditionDetails
